import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IMAGE_CONSTANTS } from '../../imageConstants';
import { ROUTER_CONSTANATS } from '../../../shared/routerUrl.constants';
@Component({
  selector: 'cf-back-arrow-plain',
  templateUrl: './back-arrow-plain.component.html',
  styleUrls: ['./back-arrow-plain.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackArrowPlainComponent implements OnInit {
  IMAGES: any = IMAGE_CONSTANTS;
  constructor() {}
  ROUTING: any = ROUTER_CONSTANATS;
  ngOnInit(): void {}
}
